import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import { REPORT_MODULE } from '../../configs/moduleNames';
import {
  createLoadByIdReducer,
  createLoadListReducer,
  createLoadParameterReducer,
  createOperationStateReducer,
} from '../../utils/getCrudConfig';
import {
  CREATE_REPORT,
  DELETE_REPORT,
  EDIT_REPORT_BY_ID,
  LOAD_REPORT_BY_ID,
  LOAD_REPORT_LIST,
  CREATE_REPORT_TEMPLATE,
  DELETE_REPORT_TEMPLATE,
  EDIT_REPORT_TEMPLATE_BY_ID,
  LOAD_REPORT_TEMPLATE_BY_ID,
  LOAD_REPORT_TEMPLATE_LIST,
  LOAD_REPORT_EXPORT_LIST,
  LOAD_REPORT_EXPORT_BY_ID,
  EDIT_REPORT_EXPORT_BY_ID,
  CREATE_REPORT_EXPORT,
  DELETE_REPORT_EXPORT, LOAD_TEMPLATE_ATTRIBUTES,
} from './actions';

const initialState = {
  reportListMeta: {},
  loadingReportList: false,
  reportList: [],
  loadingCurrentReport: false,
  currentReport: {},
  loadingEditReport: false,
  loadingDeleteReport: false,
  loadingCreateReport: false,

  reportTemplateListMeta: {},
  loadingReportTemplateList: false,
  reportTemplateList: [],
  loadingCurrentReportTemplate: false,
  currentReportTemplate: {},
  loadingEditReportTemplate: false,
  loadingDeleteReportTemplate: false,
  loadingCreateReportTemplate: false,

  reportExportListMeta: {},
  loadingReportExportList: false,
  reportExportList: [],
  loadingCurrentReportExport: false,
  currentReportExport: {},
  loadingEditReportExport: false,
  loadingDeleteReportExport: false,
  loadingCreateReportExport: false,

  loadingTemplateAttributes: false,
  templateAttributes: [],
};

const reducer = handleActions({
  ...createLoadListReducer(REPORT_MODULE + LOAD_REPORT_LIST, 'reportList', 'loadingReportList'),
  ...createLoadByIdReducer(REPORT_MODULE + LOAD_REPORT_BY_ID, 'currentReport', 'loadingCurrentReport'),
  ...createOperationStateReducer(REPORT_MODULE + EDIT_REPORT_BY_ID, 'loadingEditReport'),
  ...createOperationStateReducer(REPORT_MODULE + DELETE_REPORT, 'loadingDeleteReport'),
  ...createOperationStateReducer(REPORT_MODULE + CREATE_REPORT, 'loadingCreateReport'),

  ...createLoadListReducer(REPORT_MODULE + LOAD_REPORT_TEMPLATE_LIST, 'reportTemplateList', 'loadingReportTemplateList'),
  ...createLoadByIdReducer(REPORT_MODULE + LOAD_REPORT_TEMPLATE_BY_ID, 'currentReportTemplate', 'loadingCurrentReportTemplate'),
  ...createOperationStateReducer(REPORT_MODULE + EDIT_REPORT_TEMPLATE_BY_ID, 'loadingEditReportTemplate'),
  ...createOperationStateReducer(REPORT_MODULE + DELETE_REPORT_TEMPLATE, 'loadingDeleteReportTemplate'),
  ...createOperationStateReducer(REPORT_MODULE + CREATE_REPORT_TEMPLATE, 'loadingCreateReportTemplate'),

  ...createLoadListReducer(REPORT_MODULE + LOAD_REPORT_EXPORT_LIST, 'reportExportList', 'loadingReportExportList'),
  ...createLoadByIdReducer(REPORT_MODULE + LOAD_REPORT_EXPORT_BY_ID, 'currentReportExport', 'loadingCurrentReportExport'),
  ...createOperationStateReducer(REPORT_MODULE + EDIT_REPORT_EXPORT_BY_ID, 'loadingEditReportExport'),
  ...createOperationStateReducer(REPORT_MODULE + DELETE_REPORT_EXPORT, 'loadingDeleteReportExport'),
  ...createOperationStateReducer(REPORT_MODULE + CREATE_REPORT_EXPORT, 'loadingCreateReportExport'),

  ...createLoadParameterReducer(REPORT_MODULE + LOAD_TEMPLATE_ATTRIBUTES, 'templateAttributes', 'loadingTemplateAttributes', []),
}, initialState);

export default reducer;

export const getReportData = createSelector(
  [state => state[REPORT_MODULE]],
  state => {
    const {
      reportListMeta,
      loadingReportList,
      reportList,
      loadingCurrentReport,
      currentReport,
      loadingEditReport,
      loadingDeleteReport,
      loadingCreateReport,

      reportTemplateListMeta,
      loadingReportTemplateList,
      reportTemplateList,
      loadingCurrentReportTemplate,
      currentReportTemplate,
      loadingEditReportTemplate,
      loadingDeleteReportTemplate,
      loadingCreateReportTemplate,

      reportExportListMeta,
      loadingReportExportList,
      reportExportList,
      loadingCurrentReportExport,
      currentReportExport,
      loadingEditReportExport,
      loadingArchiveReportExport,
      loadingUnarchiveReportExport,
      loadingDeleteReportExport,
      loadingCreateReportExport,

      loadingTemplateAttributes,
      templateAttributes,
    } = state;
    return {
      reportListMeta,
      loadingReportList,
      reportList,
      loadingCurrentReport,
      currentReport,
      loadingEditReport,
      loadingDeleteReport,
      loadingCreateReport,

      reportTemplateListMeta,
      loadingReportTemplateList,
      reportTemplateList,
      loadingCurrentReportTemplate,
      currentReportTemplate,
      loadingEditReportTemplate,
      loadingDeleteReportTemplate,
      loadingCreateReportTemplate,

      reportExportListMeta,
      loadingReportExportList,
      reportExportList,
      loadingCurrentReportExport,
      currentReportExport,
      loadingEditReportExport,
      loadingArchiveReportExport,
      loadingUnarchiveReportExport,
      loadingDeleteReportExport,
      loadingCreateReportExport,

      loadingTemplateAttributes,
      templateAttributes,
    };
  },
);
